import Top from './core/top.es6';
import GameMain from './core/game_main.es6';
import Howto from './core/howto.es6';
import Resize from './common/resize.es6'

/* ====================================
 MAIN JS
 ====================================== */

const top = new Top();
const game_main = new GameMain();
const howto = new Howto();
const resize = new Resize()